<template>
    <v-col sm="6">
          <h2 class="text-center">Send me a Message</h2>
          <form>
              <v-text-field
                v-model="name"
                :error-messages="nameErrors"
                :counter="10"
                label="Name"
                required
                @input="$v.name.$touch()"
                @blur="$v.name.$touch()"
              ></v-text-field>
              <v-text-field
                v-model="email"
                :error-messages="emailErrors"
                label="E-mail"
                required
                @input="$v.email.$touch()"
                @blur="$v.email.$touch()"
              ></v-text-field>
              <v-textarea
                v-model="message"
                :error-messages="messageErrors"
                :counter="500"
                label="Message"
                required
                @input="$v.message.$touch()"
                @blur="$v.message.$touch()"
              ></v-textarea>
              <v-checkbox
                v-model="checkbox"
                :error-messages="checkboxErrors"
                label="Do you agree?"
                required
                @change="$v.checkbox.$touch()"
                @blur="$v.checkbox.$touch()"
              ></v-checkbox>

              <v-btn class="success mr-4" @click="submit" :disabled="!isFormValid">Send</v-btn>
              <v-btn @click="clear" class="warning">Clear</v-btn>
            </form>
        </v-col>
</template>

<script>
  import { validationMixin } from 'vuelidate'
  import { required, maxLength, minLength, email } from 'vuelidate/lib/validators'

  export default {
    mixins: [validationMixin],

    validations: {
      name: { required, maxLength: maxLength(50) },
      message: { required, minLength: minLength(10), maxLength: maxLength(500) },
      email: { required, email },
      checkbox: {
        checked (val) {
          return val
        },
      },
    },

    data: () => ({
      name: '',
      email: '',
      message: '',
      checkbox: false,
      isFormValid: true
    }),

    computed: {
      checkboxErrors () {
        const errors = []
        if (!this.$v.checkbox.$dirty) return errors
        !this.$v.checkbox.checked && errors.push('You must agree to continue!')
        return errors
      },
      nameErrors () {
        const errors = []
        if (!this.$v.name.$dirty) return errors
        !this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')
        !this.$v.name.required && errors.push('Name is required.')
        return errors
      },
      emailErrors () {
        const errors = []
        if (!this.$v.email.$dirty) return errors
        !this.$v.email.email && errors.push('Must be valid e-mail')
        !this.$v.email.required && errors.push('E-mail is required')
        return errors
      },
      messageErrors () {
        const errors = []
        if (!this.$v.message.$dirty) return errors
        !this.$v.message.minLength && errors.push('Message must be at least 10 characters long')
        !this.$v.message.maxLength && errors.push('Message must be at most 500 characters long')
        !this.$v.message.required && errors.push('Message is required.')
        return errors
      },
    },

    methods: {
      submit () {
        this.$v.$touch()
        console.log(this.name, this.email, this.message)
      },
      clear () {
        this.$v.$reset()
        this.name = ''
        this.email = ''
        this.message = ''
        this.checkbox = false
      },
    },
  }
</script>

<style scoped>
* {
  color: #311B92
}
</style>